import { PlatformPrimitives } from '../types/PlatformPrimitives';

/**
 * @group Constants

@summary
<blockquote>Default web platform primitives using HTML elements.</blockquote>

@example
```typescript
const webPrimitives = WebDefaults;
```
 * @internal
 */
export const WebDefaults: PlatformPrimitives = {
  View: 'div',
  Text: 'span',
  Svg: 'svg',
  Path: 'path',
  Line: 'line',
  G: 'g',
  Pressable: 'button'
}; 